<template>
    <div v-if="images"
        class="owl-carousel"
        :id="['owl-' + unitid]">
        <div v-for="img in images"
            class="item">

            <img-fallback :img="img.id"
                mode="img"
                img-format="m"
                vo-msg:placeholder="no.pic.placeholder"></img-fallback>


        </div>
    </div>
    <div v-else>
        <img-fallback mode="img"
            vo-msg:placeholder="no.pic.placeholder"></img-fallback>
    </div>
</template>

<script>
    import V from 'voUtils/V.js'



    export default {
    	voVueComponent: 'img-carousel',
    	props: {
    		images: Array,
    		default: () => [{
    			id: -1,
    			width: 450,
    			height: 300,
    			name: '//via.placeholder.com/450x300&text=No%20Image'
    		}],
    		unitid: Number,
    		unitpath: String,
    		externalpath: String,

    	},

    	mounted: function() {
    		$("#owl-" + this.unitid).owlCarousel({
    			items: 1,
    			loop: true,
    			center: false,
    			autoplay: false,
    			smartSpeed: 3000,
    			dots: true,
    			nav: true
    		});
    	},

    	methods: {
    		getTarget: function() {
    			return '_blank';
    			//return this.$root.getUnitSearchTarget();
    		},
    		getUnitPath: function() {
    			console.log('this.unitpath::' + this.unitpath)
    			console.log('this.externalpath::::::::' + this.externalpath);
    			return this.$root.getUnitSearchPath(this.unitpath, '', this.externalpath.de);
    		}
    	}

    };
</script>